export function LabelValue({ label, value }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 12, color: "#6b7280" }}>{label}</div>
      <div style={{ fontSize: 16 }}>
        {value ?? "-"}
      </div>
    </div>
  );
}